var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 11.6785L10.7667 13.3519C11.2734 13.6585 11.8934 13.2052 11.76 12.6319L11.0267 9.48521L13.4734 7.36521C13.92 6.97854 13.68 6.24521 13.0934 6.19854L9.87338 5.92521L8.61338 2.95188C8.38672 2.41188 7.61338 2.41188 7.38671 2.95188L6.12671 5.91854L2.90672 6.19188C2.32005 6.23854 2.08005 6.97188 2.52672 7.35854L4.97338 9.47854L4.24005 12.6252C4.10672 13.1985 4.72672 13.6519 5.23338 13.3452L8.00005 11.6785Z",
    fill: "#FFA726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.67255ef9a656796dd1fdf7e306782125.svg";
export { ForwardRef as ReactComponent };